/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HtmlPageConfigPageTypeRespVo } from './HtmlPageConfigPageTypeRespVo';
import {
    HtmlPageConfigPageTypeRespVoFromJSON,
    HtmlPageConfigPageTypeRespVoFromJSONTyped,
    HtmlPageConfigPageTypeRespVoToJSON,
    HtmlPageConfigPageTypeRespVoToJSONTyped,
} from './HtmlPageConfigPageTypeRespVo';

/**
 * 
 * @export
 * @interface ResponseListHtmlPageConfigPageTypeRespVo
 */
export interface ResponseListHtmlPageConfigPageTypeRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListHtmlPageConfigPageTypeRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListHtmlPageConfigPageTypeRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<HtmlPageConfigPageTypeRespVo>}
     * @memberof ResponseListHtmlPageConfigPageTypeRespVo
     */
    data?: Array<HtmlPageConfigPageTypeRespVo>;
}

/**
 * Check if a given object implements the ResponseListHtmlPageConfigPageTypeRespVo interface.
 */
export function instanceOfResponseListHtmlPageConfigPageTypeRespVo(value: object): value is ResponseListHtmlPageConfigPageTypeRespVo {
    return true;
}

export function ResponseListHtmlPageConfigPageTypeRespVoFromJSON(json: any): ResponseListHtmlPageConfigPageTypeRespVo {
    return ResponseListHtmlPageConfigPageTypeRespVoFromJSONTyped(json, false);
}

export function ResponseListHtmlPageConfigPageTypeRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListHtmlPageConfigPageTypeRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(HtmlPageConfigPageTypeRespVoFromJSON)),
    };
}

export function ResponseListHtmlPageConfigPageTypeRespVoToJSON(json: any): ResponseListHtmlPageConfigPageTypeRespVo {
    return ResponseListHtmlPageConfigPageTypeRespVoToJSONTyped(json, false);
}

export function ResponseListHtmlPageConfigPageTypeRespVoToJSONTyped(value?: ResponseListHtmlPageConfigPageTypeRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(HtmlPageConfigPageTypeRespVoToJSON)),
    };
}

